import axiosClient from "../axiosClient";

/**
 * Get Dashboard Data: Sports → Blocks → Student Counts
 */
export const getDashboardData = async (token) => {
  try {
    const res = await axiosClient.get(
      "/admin/dashboard.php",
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data; // { status, categories: [...] }
  } catch (err) {
    console.error("Dashboard API Error:", err);
    return { status: "error", message: "Unable to load dashboard data" };
  }
};

// export as named
const dashboardApi = {
  getDashboardData,
};

export default dashboardApi;
